import { Form, useFormikContext } from 'formik';
import './QueryFilterForm.scss';
import { IChildrenProp, IDiv } from 'types/components/components.interface';
import {
  Dispatch,
  ForwardedRef,
  Ref,
  SetStateAction,
  forwardRef,
  useEffect,
} from 'react';
import { useDebounce } from 'use-debounce';
import { useComponentVisible } from 'hooks';

export interface IQueryFilterFormProps<T> extends IChildrenProp, IDiv {
  isOpen?: boolean;
  onDebouncedFormChange?: (values: T) => any;
  delay?: number;
  formikClassName?: string;
}

const QueryFilterForm = <T,>(
  {
    children,
    isOpen = false,
    onDebouncedFormChange,
    delay = 1000,
    className = '',
    formikClassName = '',
    ...props
  }: IQueryFilterFormProps<T>,
  outsideRef: ForwardedRef<HTMLDivElement>
) => {
  const { values } = useFormikContext<T>();

  const [debouncedFilters] = useDebounce(values, delay);

  useEffect(() => {
    onDebouncedFormChange && onDebouncedFormChange(debouncedFilters);
  }, [debouncedFilters]);

  return !isOpen ? null : (
    <div
      ref={outsideRef}
      {...props}
      className={`query-filters-form-wrapper ${
        isOpen ? 'is-open' : ''
      } ${className}`}>
      <Form className={`query-filters-form ${formikClassName}`}>
        {children}
      </Form>
    </div>
  );
};

const ForwardedQueryFilterForm = forwardRef(QueryFilterForm) as <T>(
  props: IQueryFilterFormProps<T> & { ref?: Ref<HTMLDivElement> }
) => ReturnType<typeof QueryFilterForm>;

export default ForwardedQueryFilterForm;
